export class QuickBooksModel {
    public clientId:string;
    public secretKey:string;
    public internalCompanyId: number;
    public quickBooksConfigured: boolean;

    constructor() {
        this.quickBooksConfigured = false;
    }
}